import firebase from '../../lib/firebase.prod';

export async function sendVerifyAddressEmailToUser(salesAgentName, userEmail) {
	let emailRef = await firebase
		.database()
		.ref('/verifyAddressEmailToUser/')
		.push();

	await emailRef.set({
		salesAgentName: salesAgentName,
		userEmail: userEmail,
		subject: `${salesAgentName} has reset password. Please verify the email address.`,
	});
}
